export enum PricingOptionType {
  ACCESS_CONSTRAINT = 'ACCESS_CONSTRAINT',
  LOADING_CONSTRAINT = 'LOADING_CONSTRAINT',
  MEETING = 'MEETING',
  EUROPALLET = 'EUROPALLET',
  INCLUDED_INSURANCE = 'INSURANCE_INCLUDED',
}
